export const TASK_SUM_REQUEST = 'TASK_SUM_REQUEST';
export const TASK_SUM_SUCCESS = 'TASK_SUM_SUCCESS';
export const TASK_SUM_FAIL = 'TASK_SUM_FAIL';

export function taskRequest({prof,id}) {
    return {
        type:TASK_SUM_REQUEST,
        payload: {prof,id},
    };
}

export const ACCOUNTANT_TASK_REQUEST = 'ACCOUNTANT_TASK_REQUEST';
export const ACCOUNTANT_TASK_SUCCESS = 'ACCOUNTANT_TASK_SUCCESS';
export const ACCOUNTANT_TASK_FAIL = 'ACCOUNTANT_TASK_FAIL';

export function accountantRequest() {
    return {
        type:ACCOUNTANT_TASK_REQUEST,
        payload: {},
    };
}

export const COMPANY_TASK_REQUEST = 'COMPANY_TASK_REQUEST';
export const COMPANY_TASK_SUCCESS = 'COMPANY_TASK_SUCCESS';
export const COMPANY_TASK_FAIL = 'COMPANY_TASK_FAIL';

export function taskCompanyRequest() {
    return {
        type:COMPANY_TASK_REQUEST,
        payload: {},
    };
}

export const MANAGER_TASK_REQUEST = 'MANAGER_TASK_REQUEST';
export const MANAGER_TASK_SUCCESS = 'MANAGER_TASK_SUCCESS';
export const MANAGER_TASK_FAIL = 'MANAGER_TASK_FAIL';

export function taskManagerRequest() {
    return {
        type:MANAGER_TASK_REQUEST,
        payload: {},
    };
}

export const GET_TASK_REQUEST = 'GET_TASK_REQUEST';
export const GET_TASK_SUCCESS = 'GET_TASK_SUCCESS';
export const GET_TASK_FAIL = 'GET_TASK_FAIL';

export function taskDataRequest(query) {
    return {
        type:GET_TASK_REQUEST,
        payload: {query},
    };
}

export const ADD_TASK_LOCAL = 'ADD_TASK_LOCAL';

export function taskAddLocalRequest(data) {
    return {
        type:ADD_TASK_LOCAL,
        payload: {data},
    };
}

